var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":_vm.policiesList[_vm.name].title,"isStandalone":""}},[_c('iframe',{staticClass:"flex-grow-1",attrs:{"src":_vm.policiesList[_vm.name].embedURL}})])}
var staticRenderFns = []

export { render, staticRenderFns }